module.exports = __webpack_public_path__ + "img/duopingtai_app.caf86c44.png";